import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicRefund({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M3.14 6.39c.33 0 .6.24.65.56l.01.82c1.16-.6 1.94-.86 2.4-.74l4.2.93.06.02c.6.23 1 .94.9 1.64l2.68-.96c.4-.14.84-.09 1.2.15.3.2.53.5.65.85.29.8.07 1.8-.82 2.39-.9.59-4.35 2.5-4.58 2.58-.42.12-.93.34-2.2.1l-2.78-.5c-.29-.06-.9-.25-1.71-.05v.45a.66.66 0 01-.66.59H.66a.66.66 0 01-.66-.66V7.05c0-.37.3-.66.66-.66h2.48zM2.5 7.7H1.32v6.2h1.17V7.7zm3.35.6c-.2-.01-.7.18-1.44.58l-.19.1-.4.23-.01 3.68.4-.04c.4-.05.64-.04 1 .02l.2.04 3.15.52c.51.1 1.05.08 1.55-.07a72.3 72.3 0 004.53-2.4c.44-.34.17-1.43-.54-1.1-.3.11-3.48 1.38-3.7 1.44-.2.06-.46.14-.67.14-.11 0-.22-.01-.32-.04l-.1-.03-2.27-.56a.66.66 0 01.22-1.3l.1.02 2.31.57h.1c.41-.17.43-.72.32-.86l-.04-.02L5.9 8.3h-.05zM9.5.44a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5zm0 1.5a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicRefund.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicRefund.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicRefund svgRef={ref} {...props} />);
export default ForwardRef;
